import { parseQueryString } from 'app/util/query-string';
import { FieldNames } from '../names';
import { RebelIqQueryStringKeys } from './types';

export const getRebelIqFromQueryString = (): object => {
  const values = parseQueryString(Object.values(RebelIqQueryStringKeys)) || {};
  const formValues = {};

  formValues[FieldNames.email]                 = values[RebelIqQueryStringKeys.email] || '';
  formValues[FieldNames.lastName]              = values[RebelIqQueryStringKeys.lastName] || '';
  formValues[FieldNames.creditScore]           = values[RebelIqQueryStringKeys.fico] || '';
  formValues[FieldNames.homeEquityLoanPurpose] = values[RebelIqQueryStringKeys.homeEquityLoanPurpose] || '';
  formValues[FieldNames.homeValue]             = values[RebelIqQueryStringKeys.homeValue] || '';
  formValues[FieldNames.loanAmount]            = values[RebelIqQueryStringKeys.loanAmount] || '';
  formValues[FieldNames.mortgageBalance]       = values[RebelIqQueryStringKeys.mortgageBalance] || 0;
  formValues[FieldNames.propertyCity]          = values[RebelIqQueryStringKeys.propertyCity] || '';
  formValues[FieldNames.propertyState]         = values[RebelIqQueryStringKeys.propertyState] || '';
  formValues[FieldNames.propertyStreet]        = values[RebelIqQueryStringKeys.propertyStreet] || '';
  formValues[FieldNames.propertyZip]           = values[RebelIqQueryStringKeys.propertyZip] || '';
  formValues[FieldNames.propertyType]          = values[RebelIqQueryStringKeys.propertyType] || '';
  formValues[FieldNames.propertyUsage]         = values[RebelIqQueryStringKeys.propertyUsage] || '';
  
  return formValues;
};
/**
 * Form fields that must be populated from the Rebel IQ query string for the Home Equity Turbo Welcome
 * form to price a HELOC and to identify the borrower.
 */
const REQUIRED_REBEL_IQ_FIELDS: FieldNames[] = [
  FieldNames.creditScore,
  FieldNames.email,
  FieldNames.homeEquityLoanPurpose,
  FieldNames.homeValue,
  FieldNames.lastName,
  FieldNames.loanAmount,
  FieldNames.propertyCity,
  FieldNames.propertyState,
  FieldNames.propertyStreet,
  FieldNames.propertyType,
  FieldNames.propertyUsage,
  FieldNames.propertyZip,
];

/**
 * Checks whether the form values hold every field the Home Equity Turbo Welcome form needs from the
 * Rebel IQ query string. A field is missing when the query string had no value for it.
 *
 * @param {object} [values] - Form values, initialized from {@link getRebelIqFromQueryString}.
 * @returns {boolean} True when every required field has a value.
 */
export const hasRequiredRebelIqValues = (values: object = {}): boolean => {
  return REQUIRED_REBEL_IQ_FIELDS.every((field) => {
    const value = values[field];
    return value !== undefined && value !== null && String(value).trim() !== '';
  });
};
